export const NETWORK_START = 'auth/NETWORK_START';
export const NETWORK_RESET = 'auth/NETWORK_RESET';
export const NETWORK_ERROR = 'auth/NETWORK_ERROR';
export const USER_LOGIN = 'auth/USER_LOGIN';
export const USER_LOGOUT = 'auth/USER_LOGOUT';
export const IS_AUTHENTICATED_SET = 'auth/IS_AUTHENTICATED_SET';
export const IS_AUTHENTICATING_SET = 'auth/IS_AUTHENTICATING_SET';



// WEBPACK FOOTER //
// ./src/modules/auth/actionTypes.js